<template>
    <div class="container card shadow col-md-12 m-auto">
        <div class="card-header py-3 card-header-main">
            <h6 class="m-0 text-primary">Questionnaire {{questionnaire.title}}</h6>
        </div>
        <div class="card-body">
            <div>
                <b-alert dismissible
                         fade
                         :class="{'alert-danger' : success === false, 'alert-success' : success === true}"
                         :show="saveMessage !== ''">
                    {{saveMessage}}
                </b-alert>
            </div>
            <div class="card shadow mb-4">
                <div class="card-header card-header-secondary mb-3">
                    <h6 class="m-0 text-primary">Meta <icon class="header-chevron-icon" icon="chevron-up" @click="metaCollapsed = !metaCollapsed" v-b-toggle.collapseQuestionnaireMeta :class="{'rotate' : metaCollapsed}"></icon></h6>
                </div>
                <div>
                    <b-collapse id="collapseQuestionnaireMeta" v-model="metaCollapse" >
                        <div class="form-group col-12">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-lg">Title</span>
                                </div>
                                <input v-model="questionnaire.title" type="text" class="form-control" placeholder="Enter Title">
                            </div>
                        </div>
                        <div class="form-group col-12">
                            <div class="input-group-prepend w-100">
                                <span class="input-group-text w-100">Information</span>
                            </div>
                            
                            <html-editor v-model="questionnaire.information"/>
                        </div>
                        <div class="form-group col-12">
                            <div class="input-group-prepend w-100">
                                <span class="input-group-text w-100">Interpretation</span>
                            </div>

                            <html-editor v-model="questionnaire.interpretation"/>
                        </div>
                        <div class="form-group col-12">
                            <button @click="editQuestionnaire" class="btn btn-primary">Save</button>
                        </div>
                    </b-collapse>                
                </div>
            </div>
            <div class="card  shadow mb-4">
                <div class="card-header card-header-secondary">
                    <h6 class="m-0 text-primary">Questions <icon class="header-chevron-icon" icon="chevron-up" @click="questionCollapsed = !questionCollapsed" v-b-toggle.collapseQuestionnaireQuestions :class="{'rotate' : questionCollapsed}"></icon></h6>
                </div>  
                <div class="card-body">
                    <b-collapse id="collapseQuestionnaireQuestions">
                        <div >
                            <button class="mb-4 btn btn-primary" type="button" @click="saveChanges">Save</button>
                            <hr/>
                            <questions
                                @questionsChanged="questionsChanged"
                                :saved="saved"
                                :save="save"
                                :questionnaireId="this.$route.params.questionnaireId"></questions>
                            <hr />
                            <button class="mt-4 btn btn-primary" type="button" @click="saveChanges">Save</button>
                        </div>
                    </b-collapse>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Questions from '../admin/partials/Questions';
import HtmlEditor from './../../misc/HtmlEditor';

export default {
    components:{
        questions: Questions,
        HtmlEditor
    },
    data() {
        return {
            metaCollapse: true,
            metaCollapsed: false,
            questionCollapsed: true,
            questionnaire: {
                title: null,
            },
            response: {},
            selectedQuestionnaireInformationIndex: 0,
            save: false,
            saved: false,
            saveMessage: '',
            success: null,
        }
    },
    methods: {
        editQuestionnaire: function(){
            
            let self = this;
            this.$http.put('/api/questionnaires/edit/', this.questionnaire)
            .then(response => {
                self.saved = true
                setTimeout(() => {
                    self.saved = false
                }, 500)
                self.success = true
                self.saveMessage = 'Your changes were saved successfully!'
                setTimeout(() => {
                    self.saveMessage = ''
                    self.success = null
                }, 3000)
            })
            .catch(error => {
                self.success = false
                self.saveMessage = 'There was an error while trying to save your changes'
                setTimeout(() => {
                    self.saveMessage = ''
                    self.success = null
                }, 3000)
                console.log(error)
            })
            
        },
        questionsChanged: function(questions, questionnaireId){
            this.questionnaire['questions'] = questions
        },
        saveChanges: function(){
            let self = this
            self.save = true
            setTimeout(() => {
                self.save = false
            }, 500)
            this.$http.put(`/api/questionnaires/save/${this.$route.params.questionnaireId}`, this.questionnaire)
            .then(response => {
                self.saved = true
                setTimeout(() => {
                    self.saved = false
                }, 500)
                self.success = true
                self.saveMessage = 'Your changes were saved successfully!'
                setTimeout(() => {
                    self.saveMessage = ''
                    self.success = null
                }, 3000)
            })
            .catch(error => {
                self.success = false
                self.saveMessage = 'There was an error while trying to save your changes'
                setTimeout(() => {
                    self.saveMessage = ''
                    self.success = null
                }, 3000)
                console.log(error)
            })
        },
        loadQuestionnaire: function()
        {
            let self = this;
            this.$http.get('/api/questionnaires/get/' + this.$route.params.questionnaireId)
            .then(response => {
                self.questionnaire = response.data;
            })
            .catch(error => {
                console.log(error);
                self.$router.push("/404");
            })
        },
        loadQuestionnaireInformations: function(){
            let self = this;
            this.$http.get('/api/questionnaires/informations/get-all-per-questionnaire/' + this.$route.params.questionnaireId)
            .then(response => {
                self.questionnaireInformations = response.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
        onSelect: function(value)
        {
            this.selectedQuestionnaireInformationIndex = value;
        }
    },
    mounted: function() {
        this.loadQuestionnaire();
        this.loadQuestionnaireInformations();
    },
    computed: {
        languages: function(){
            return this.$store.getters.systemLanguages;
        },
        languagesMap: function(){
            return this.languages.reduce(function(map, obj){
                map[obj.id] = obj.longTitle;
                return map
            }, {});
        }
    }
}
</script>

<style lang="scss" scoped>
.tab-content {
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    padding: 10px;
}
.col-md-12
{
    padding-right: 0rem;
    padding-left: 0rem;
}
.nav-tabs {
    margin-bottom: 0;
}
h5{
    font-size: 20px;
}

    svg {
        &[data-icon="chevron-up"]
        {
            transition: 0.5s;
            &.rotate {
                transition: 0.5s;
                transform: rotate(180deg);
            }

        }
    }

    .header-chevron-icon {
        position: relative;
        top: -2px;
        left: 2px;
    }
</style>


